var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    fillRule: "evenodd",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M47 30c-9.38 0-17 7.617-17 17s7.62 17 17 17 17-7.617 17-17-7.62-17-17-17zM22.11 44h4.49c1.1 0 2-.896 2-2s-.9-2-2-2h-5.12c-.31-2.541-.48-5.225-.48-8s.17-5.459.48-8h21.04c.09.752.17 1.516.24 2.292.09 1.099 1.06 1.915 2.16 1.82s1.92-1.064 1.82-2.164A59.78 59.78 0 0 0 46.55 24h12.29A28.16 28.16 0 0 1 60 32c0 1.104.9 2 2 2s2-.896 2-2C64 14.476 49.88.224 32.41.003L32 0l-.41.003C14.12.224 0 14.476 0 32s14.12 31.776 31.59 31.997L32 64c1.1 0 2-.895 2-1.998v-.004C34 60.895 33.1 60 32 60c-2.28 0-4.24-1.911-5.95-4.809-1.7-2.876-3.06-6.726-3.94-11.191zM47 34c7.17 0 13 5.825 13 13s-5.83 13-13 13-13-5.825-13-13 5.83-13 13-13zM18.06 44H6.7c3.31 6.964 9.41 12.347 16.86 14.702a21.36 21.36 0 0 1-.96-1.476c-1.98-3.355-3.57-7.921-4.54-13.226zM53 45h-4v-7c0-1.104-.9-2-2-2s-2 .896-2 2v9c0 1.105.89 2 2 2h6c1.1 0 2-.896 2-2s-.9-2-2-2zM17.46 24H5.16a28.155 28.155 0 0 0 0 16h12.3c-.3-2.554-.46-5.235-.46-8s.16-5.446.46-8zm.6-4c.97-5.305 2.56-9.871 4.54-13.226.31-.521.63-1.013.96-1.476C16.11 7.653 10.01 13.036 6.7 20zm23.82 0c-.99-5.093-2.61-9.385-4.65-12.328C35.68 5.443 33.96 4 32 4c-2.28 0-4.24 1.911-5.95 4.809-1.7 2.876-3.06 6.726-3.94 11.191zm15.42 0c-3.31-6.962-9.41-12.345-16.85-14.701l.06.092C42.9 8.837 44.84 13.937 45.95 20z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageNews);
export default __webpack_public_path__ + "static/media/manage-news.6c73dd778e7bacb5a34c31c949e01a8d.svg";
export { ForwardRef as ReactComponent };